import { createAction } from "redux-actions";

const PREFIX = "LOGS";

export const addLogAction = createAction(`${PREFIX}/ADD_LOG_ACTION`);
export const clearLogs = createAction(`${PREFIX}/CLEAR_LOGS`);
